import API from '@aws-amplify/api';
import { selector } from 'recoil';
import { getUserListInProjectByProjectId, getUserPermissionToViewKnowledge } from '@/service/userService';
import { projectInuseDetailAtom } from '../atom/projectAtom';
import { userPermissionToViewKnowledgeAtom, getUserListByProjectAtom } from '../atom/userAtom';


/**
 * Get user list by project selector
 * params: projectId, corporationId
 */
export const getUserListByProjectSelector = selector({
    key: 'getUserListByProjectSelector',
    get: async ({ get }) => {
        try {
            let projectInuseDetail = get(projectInuseDetailAtom);
            let userList = await getUserListInProjectByProjectId(API, projectInuseDetail.id);
            
            return userList;
        } catch (err) {
            console.error(`getUserListByProjectSelector error: ${err}`);
            return [];
        }
    },
    set: ({ get, set }, data) => {
        set(getUserListByProjectAtom, data);
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent',
    },
});

export const getUserPermissionToViewKnowledgeSelector = selector({
    key: 'getUserPermissionToViewKnowledgeSelector',
    get: async () => {
        try {
            return await getUserPermissionToViewKnowledge();
        } catch (err) {
            console.log('getUserPermissionToViewKnowledgeSelector err :', err);
            return {};
        }
    },
    set: ({ get, set }, data) => {
        set(userPermissionToViewKnowledgeAtom, data);
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent'
    }
});


